import { Component, OnInit } from '@angular/core';
import { RoutingService, UserIdService } from '@spartacus/core';
import { CartUtilsService } from '@spartacus/quote/core';
import { GonvarriActiveCartService } from 'src/app/core/services/gonvarri-active-cart.service';

const SUCCESS = "SUCCESS";

@Component({
    selector: 'app-gonvarri-order-express',
    templateUrl: './gonvarri-order-express.component.html',
    styleUrl: './gonvarri-order-express.component.scss',
    standalone: false
})
export class GonvarriOrderExpressComponent implements OnInit {

  orderNumber: String = "";
  isAgreed: boolean = false;
  userId: string = "";
  cartId: string = "";


  constructor(
    private activeCartService: GonvarriActiveCartService,
    private userIdService: UserIdService,
    private routingService: RoutingService
  ) {}

  ngOnInit(): void {
    this.activeCartService.getActive().subscribe(cart => {
      this.cartId = cart.code as string;
    });
    this.userIdService.getUserId().subscribe(userId => {
      this.userId = userId;
    });
  }

  addToCart(): void {
    this.activeCartService
      .checkoutExpress(Number(this.orderNumber), this.userId, this.cartId)
      .subscribe(data => {
        if(data.message.includes(SUCCESS)) {
          this.routingService.goByUrl("/checkout/review-order");
        }
      });
  }

}
